export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_ISO_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const DATE_TIME_ISO_T_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_TIME_ISO_FORMAT = 'YYYY-MM-DD HH:mm';

export const TIME_FORMAT = 'HH:mm';
export const TIME_FORMAT_12H = 'hh:mm A';

export const DATE_TIME_FORMAT_12H = 'DD.MM.YYYY hh:mm A';

export const DATE_PIPE_WITH_COMMA = 'DD.MM.YYYY, HH:mm';
export const DATE_PIPE_WITH_COMMA_12H = 'DD.MM.YYYY, hh:mm A';

export const WIDGET_TIME_FORMAT = {
  AUTO: 'auto',
  HOURS_12: '12_hours',
  HOURS_24: '24_hours'
} as const;

export type WidgetTimeFormat = typeof WIDGET_TIME_FORMAT[keyof typeof WIDGET_TIME_FORMAT];
